/* Site-Specific JavaScript */
jq(document).ready(function () {
    const pathname = window.location.pathname;
    jq('.module-quick-links a').each(function () {
        if (this.getAttribute('href') === pathname) {
            this.parentElement.classList.add('active');
            this.setAttribute('aria-current', 'page');
        }
    })

    // change radio button
    jq('[id^=ir-sec-all]').change();
})

// client javascripts
jq(document).ready(function () {
    // Footer accordion functionality
    jq('.footer-accordion').on('click', function(e) {
        e.preventDefault();
        
        var $accordion = jq(this);
        var $list = $accordion.siblings('.footer-list1');
        var $icon = $accordion.find('.fas');
        
        // Toggle accordion-closed class
        $list.toggleClass('accordion-closed');
        
        // Toggle icon between plus and minus
        if ($list.hasClass('accordion-closed')) {
            $icon.removeClass('fa-minus').addClass('fa-plus');
        } else {
            $icon.removeClass('fa-plus').addClass('fa-minus');
        }
    });
    
    // Client header navigation hover functionality
    var $optionLinks = jq('.option-links ul li');
    var $buildingWrappers = jq('.right-menu-links .building_wrapper_sublink');
    var $navigationContainer = jq('.navigation-block-container.large-screen');
    var currentActiveIndex = 0;
    
    if ($optionLinks.length > 0 && $buildingWrappers.length > 0) {
        // Hide all building_wrapper_sublink except the first one by default
        $buildingWrappers.not(':first').hide();
        $buildingWrappers.first().show();
        
        // Handle hover on option links (excluding the last one which is Product Finder link)
        $optionLinks.slice(0, 4).on('mouseenter', function() {
            var index = $optionLinks.index(this);
            currentActiveIndex = index;
            
            // Hide all building_wrapper_sublink
            $buildingWrappers.hide();
            
            // Show the corresponding building_wrapper_sublink (index 0 = first, 1 = second, etc.)
            if (index >= 0 && index < $buildingWrappers.length) {
                $buildingWrappers.eq(index).show();
            }
        });
        
        // Keep the active one visible when hovering over the content area
        jq('.right-menu-links').on('mouseenter', function() {
            // Keep the current active one visible
            $buildingWrappers.hide();
            if (currentActiveIndex >= 0 && currentActiveIndex < $buildingWrappers.length) {
                $buildingWrappers.eq(currentActiveIndex).show();
            }
        });
        
        // When mouse leaves the entire navigation container, show the first one again
        $navigationContainer.on('mouseleave', function() {
            $buildingWrappers.hide();
            $buildingWrappers.first().show();
            currentActiveIndex = 0;
        });
    }
})